// settings for header

export const headerScroll = () => {
  const header = document.querySelector('.js-header') as HTMLElement;
  const mv = document.querySelector('.mv') as HTMLElement;
  const logo = document.querySelector('.header__logo') as HTMLElement;

  if (!header || !logo) return;
  const headerHeight = header.offsetHeight;
  const mvHeight = mv?.offsetHeight;

  window.addEventListener('scroll', () => {
    if (window.scrollY > headerHeight * 2) {
      header.classList.add('header--scrolled');
      logo.classList.add('scrolled');
    } else {
      header.classList.remove('header--scrolled');
      logo.classList.remove('scrolled');
    }

    if (mv) {
      if (window.scrollY > mvHeight) {
        header.classList.add('header--fixed');
        logo.classList.add('fixed');
      } else {
        header.classList.remove('header--fixed');
        logo.classList.remove('fixed');
      }
    } else {
      if (window.scrollY > window.innerHeight / 1.5) {
        header.classList.add('header--fixed');
        logo.classList.add('fixed');
      } else {
        header.classList.remove('header--fixed');
        logo.classList.remove('fixed');
      }
    }
  });

  if (window.scrollY > headerHeight * 2) {
    header.classList.add('header--scrolled');
  } else {
    header.classList.remove('header--scrolled');
  }

  if (window.scrollY > mvHeight) {
    header.classList.add('header--fixed');
  } else {
    header.classList.remove('header--fixed');
  }
};

export const headerHamburger = () => {
  const trigger = document.querySelector(
    '.js-hamburger-trigger'
  ) as HTMLElement;
  const hamburger = document.querySelector('.js-hamburger-menu') as HTMLElement;
  const header = document.querySelector('.js-header') as HTMLElement;
  const hamburgerContent = document.querySelector(
    '.header__dropdown-menu-content'
  ) as HTMLElement;
  const logoAlt = '地崎道路株式会社リクルートサイト';
  const logoImg = document.querySelector(
    '.image.image--contain.fixed'
  ) as HTMLImageElement;
  const links = document.querySelectorAll('a');

  if (!hamburger || !header || !trigger) return;

  trigger.addEventListener('click', () => {
    hamburger.classList.toggle('active');
    trigger.classList.toggle('hamburger--active');
    header.classList.toggle('header--active');
    logoImg.setAttribute(
      'alt',
      header.classList.contains('header--active') ? '' : logoAlt
    );
  });

  document.addEventListener('click', (e) => {
    if (
      !trigger.contains(e.target as Node) &&
      !hamburgerContent.contains(e.target as Node)
    ) {
      hamburger.classList.remove('active');
      trigger.classList.remove('hamburger--active');
      header.classList.remove('header--active');
    }
  });

  links.forEach((link) => {
    link.addEventListener('click', () => {
      hamburger.classList.remove('active');
      trigger.classList.remove('hamburger--active');
      header.classList.remove('header--active');
      logoImg.setAttribute('alt', logoAlt);
    });
  });
};
